import { Breadcrumbs } from '@graftcode/design-system'

import { ACADEMY_HEADER_NAV_TEST_IDS } from '@/shared/docs-test-ids.const'

import { buildNavbarBreadcrumbItems } from './mappers/buildNavbarBreadcrumbItems'
import type { NavbarBreadcrumbsProps } from './types'

export function NavbarBreadcrumbs({ segments }: NavbarBreadcrumbsProps) {
  if (segments.length === 0) return null

  const items = buildNavbarBreadcrumbItems(segments)

  return (
    <div data-testid={ACADEMY_HEADER_NAV_TEST_IDS.breadcrumbs}>
      <Breadcrumbs showFirst={true} items={items} size="m" />
    </div>
  )
}
